import React, { FC } from 'react';

import { useI18n } from '#hooks/useI18n';
import { css } from '@emotion/react';
import styled from '@emotion/styled';

import { Flex, LinkIcon, Semibold } from '@zazume/zzm-base';

import { ZazumeRoute } from '#/containers/router/routes/types';
import { useRouter } from '#/hooks';

const LinkContainer = styled.div<any>(
  ({ theme }) => css`
    display: inline-block;
    vertical-align: center;
    margin-left: ${theme.spacing.s2};
    align-items: center;
    cursor: pointer;

    &:hover {
      color: ${theme.colors.PrimaryDark2};
    }
  `
);

interface LinkProps {
  to: ZazumeRoute;
  openInNewTab?: boolean;
}

export const Link: FC<LinkProps> = ({ to, openInNewTab = false }) => {
  const { t } = useI18n();
  const { navigate } = useRouter();

  const goTo = () => {
    if (openInNewTab) {
      window.open(to, '_blank');
      return;
    }
    navigate(to, { canGoBack: true });
  };

  return (
    <LinkContainer onClick={goTo}>
      <Flex align="center" gap="s2">
        <Semibold variant="S" color="Primary">
          {t('general.view')}
        </Semibold>
        <LinkIcon size={16} color="Primary" />
      </Flex>
    </LinkContainer>
  );
};
